import { blue, green, grey, orange } from '@mui/material/colors';
import { CommissionRecalculationTaskStatus } from 'types/embedded/commissionRecalculationTask';

export const TASK_STATUS_COLORS: Record<CommissionRecalculationTaskStatus | 'default', string> = {
  [CommissionRecalculationTaskStatus.Created]: blue[600],
  [CommissionRecalculationTaskStatus.Pending]: grey[400],
  [CommissionRecalculationTaskStatus.InProgress]: orange[400],
  [CommissionRecalculationTaskStatus.Completed]: green[500],
  default: blue[600],
};
